module.exports = __webpack_public_path__ + "static/media/profile.5a3c59df.svg";